import { Dispatch } from "react";
import {
  D2DRequestsAction,
  setPageAction,
  setPageRowSizeAction,
} from "./reducers/actons";

export const onRowsPerPageChange = (
  dispatch: Dispatch<D2DRequestsAction>,
  updatedRowsPerPage: number
): void => {
  dispatch(setPageRowSizeAction(updatedRowsPerPage));
  dispatch(setPageAction(1));
};

export const onFirstPageClick = (
  dispatch: Dispatch<D2DRequestsAction>
): void => {
  dispatch(setPageAction(1));
};

export const onPreviousPageClick = (
  dispatch: Dispatch<D2DRequestsAction>,
  currentPage: number
): void => {
  dispatch(setPageAction(Math.max(currentPage - 1, 1)));
};

export const onNextClick = (
  dispatch: Dispatch<D2DRequestsAction>,
  currentPage: number
): void => {
  dispatch(setPageAction(currentPage + 1));
};

export const onLastPageClick = (
  dispatch: Dispatch<D2DRequestsAction>,
  pageRowSize: number,
  totalCount: number
): void => {
  dispatch(setPageAction(Math.max(Math.ceil(totalCount / pageRowSize), 1)));
};
